// extracted by mini-css-extract-plugin
export default {"button":"sr","primary":"tr","fullWidth":"ur","secondary":"vr","nutrition":"wr","underlined":"xr","small":"yr","medium":"zr","info":"Ar","white":"Br","border":"Cr","mango":"Er","charcoal":"Fr","court":"Gr","green":"Hr","spark":"Ir","linkButton":"Jr","disabled":"Kr"};
    if(module.hot) {
      // 1715276855658
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  